export default __webpack_public_path__ + "static/media/Aurora - Twinhouse.c3c9cd7c.svg";